import React from 'react';
import { Container } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import UserSummaryContent from './UserSummaryContent';

const UserSummary = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  const handleUserChange = (newUserId) => {
    navigate(`/users/${newUserId}/summary`, { replace: true });
  };

  return (
    <Container maxWidth="xl" sx={{ pt: 3, pb: 6 }}>
      <UserSummaryContent
        userId={userId}
        isModal={false}
        onUserChange={handleUserChange}
      />
    </Container>
  );
};

export default UserSummary;
